<template>
	<div :id="blok._uid">
		<div class="relative inset-x-1/2 mx-[-50vw] w-screen">
			<span
				v-if="darkeningEnabled"
				role="presentation"
				class="absolute inset-0 rounded bg-black/20"
			></span>

			<nuxt-picture
				v-if="blok.image?.filename"
				:src="blok.image?.filename"
				:alt="blok.title"
				provider="storyblok"
				loading="lazy"
				sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw 3xl:100vw"
				:img-attrs="{
					class: 'w-screen aspect-[2.25/1] object-cover h-96 lg:h-[30rem]',
				}"
			/>

			<div
				class="absolute inset-x-1 top-0 z-10 mx-auto flex size-full flex-col justify-center px-md lg:h-3/4"
			>
				<p
					class="z-10 mx-auto w-full px-md text-center font-prenton-cond text-6xl font-bold text-white md:text-8xl lg:text-10xl"
				>
					{{ blok.title }}
				</p>

				<v-button
					v-if="blok.button_text !== '' && blok.button_link !== undefined"
					:to="
						blok.button_link.url
							? blok.button_link.url
							: blok.button_link.cached_url
					"
					size="wide"
					theme="gray"
					class="mx-auto mt-md w-full text-center md:w-1/2 lg:w-1/3"
					@click="onButtonClick"
				>
					{{ blok.button_text }}
				</v-button>
			</div>
		</div>

		<div v-if="!inWideSlider" class="relative rounded-xs bg-white lg:-mt-28">
			<v-h5
				v-if="blok.content_title !== ''"
				class="pt-xl text-center uppercase"
			>
				{{ blok.content_title }}
			</v-h5>

			<div
				class="grid grid-cols-2 rounded-xs md:grid-cols-3 lg:auto-cols-auto lg:grid-flow-col lg:grid-cols-none"
			>
				<template v-for="content in blok.content" :key="content._uid">
					<v-storyblok-component :blok="content" />
				</template>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-info" | "sb-info-item"}>;
}>();

const darkeningEnabled = computed<boolean>(
	() => properties.blok?.enable_darkening ?? false,
);

const inWideSlider = inject("sb.inWideSlider", false);
const {$eventbus} = useNuxtApp();

function onButtonClick(event: Event) {
	const target = event.target as HTMLAnchorElement;

	if (target.href.includes("/account")) {
		$eventbus.emit("open-login-modal");

		event.preventDefault();
	}
}
</script>
